import { AwaitingPaymentSmall } from '../AwaitingPayment';
import { AwaitingExamSmall } from '../AwaitingExam';
import { AwaitingAnamneseSmall } from '../AwaitingAnamnese';
import { AwaitingScheduleReturnSmall } from '../AwaitingScheduleReturn';
import { EnumJourneyAction, getJourneyAction } from '../../../../utils/enum/journeyAction';
import { AwaitingScheduleSmall } from '../AwaitingSchedule';
import { ReportAvailableSmall } from '../ReportAvailable';
import { VideoCallAvailableSmall } from '../VideoCallAvailable';
import { IJourneyResp } from '../../../../services/journey.service';
import { ExamAvailableSmall } from '../ExamAvailable';
import { MedicalRequestAvailableSmall } from '../MedicalRequestAvailable';
import { AwaitingConsultationSmall } from '../AwaitingConsultation';

interface Props {
  journey: IJourneyResp;
}

const JourneyPeding = ({ journey }: Props) => {
  const status = getJourneyAction(journey);

  if (status === EnumJourneyAction.AWAITING_PAYMENT) return <AwaitingPaymentSmall journey={journey} />;
  if (
    (status === EnumJourneyAction.AWAITING_CONSULTATION && journey.haveToAnswerAnamnese) ||
    (status === EnumJourneyAction.VIDEOCALL_AVAILABLE && journey.haveToAnswerAnamnese)
  )
    return <AwaitingAnamneseSmall journey={journey} />;
  if (status === EnumJourneyAction.AWAITING_EXAM && journey.haveToAnswerAnamnese)
    return <AwaitingAnamneseSmall journey={journey} />;
  if (status === EnumJourneyAction.AWAITING_EXAM) return <AwaitingExamSmall journey={journey} />;
  if (status === EnumJourneyAction.AWAITING_SCHEDULE_RETURN && journey.canScheduleReturn)
    return <AwaitingScheduleReturnSmall journey={journey} />;
  if (status === EnumJourneyAction.AWAITING_SCHEDULE) return <AwaitingScheduleSmall journey={journey} />;
  if (status === EnumJourneyAction.RESPORT_AVAILABLE) return <ReportAvailableSmall journey={journey} />;
  if (status === EnumJourneyAction.EXAME_AVAILABLE) return <ExamAvailableSmall journey={journey} />;
  if (status === EnumJourneyAction.MEDICAL_REQUEST_AVAILABLE)
    return <MedicalRequestAvailableSmall journey={journey} />;
  if (status === EnumJourneyAction.AWAITING_CONSULTATION) return <AwaitingConsultationSmall journey={journey} />;
  if (status === EnumJourneyAction.VIDEOCALL_AVAILABLE) return <VideoCallAvailableSmall journey={journey} />;

  return null;
};

export default JourneyPeding;
